import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="email"
export default class extends Controller {
  static targets = ['query', 'emailErrorMessage'];

  checkEmail() {
    const email = this.queryTarget.value.replace(/\s+/g, '');

    if (this.validateEmail(email)) {
      // make an api call to check if the email already exists
      // if it exits show an error message in emailErrorMessageTarget
      fetch(`/admin/users/check_email?email=${encodeURIComponent(email)}`)
        .then(response => response.json())
        .then(data => {
          if (data.exists) {
            // add class to emailErrorMessageTarget
            this.emailErrorMessageTarget.classList.add('alert', 'alert-danger');
            this.emailErrorMessageTarget.innerHTML = `A user with this email already exists. <a href='/admin/users/${data.user_id}/edit'>View User</a>`;
          } else {
            // remove class from emailErrorMessageTarget
            this.emailErrorMessageTarget.classList.remove('alert', 'alert-danger');
            this.emailErrorMessageTarget.textContent = '';
          }
        })
        .catch(error => {
          this.emailErrorMessageTarget.textContent = 'An error occurred while checking the email.';
        });
    } else {
      this.emailErrorMessageTarget.classList.remove('alert', 'alert-danger');
      this.emailErrorMessageTarget.textContent = '';
    }
  }

  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
  }
}
